import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import InfiniteScroll from 'react-infinite-scroller'
import moment from 'moment'
import Helmet from 'react-helmet'

import '@loyal_template/order.css'
import 'react-placeholder/lib/reactPlaceholder.css'

import LoggedSidebar from 'App/Shell/LoggedSidebar'
import Filters from '../Extract/Details/Filters'
import tabs from '../Extract/Details/tabs'
import { constants } from './'
import { ProductOrderList } from './ProductOrderList'
import { Title } from './Title'
import MyOrdersPlaceholderItem from './MyOrdersPlaceholderItem'

class MyOrders extends Component {
  constructor (props) {
    super(props)
    this.state = {
      endDate: new Date(),
      initialDate: moment(new Date())
        .subtract(this.props.daysFilter, 'days')
        .toDate(),
      pageSize: 10,
      filterSelected: tabs[0].options[2].value,
      currentTab: tabs[0]
    }

    this.selectOnChange = this.selectOnChange.bind(this)
  }

  loadMyOrders = (page, days) => {
    if (this.props.hasMoreItems) {
      const initialDate =
        days !== undefined
          ? moment(this.state.endDate)
            .subtract(days, 'days')
            .toDate()
          : undefined

      initialDate && this.setState({ initialDate: initialDate })

      if (!this.props.loading || this.props.page === 0) {
        this.props.loadMyOrders(
          page !== undefined ? page : this.props.page + 1,
          this.state.pageSize,
          '',
          ''
        )
      }
    }
  }

  selectOnChange = e => {
    this.props.setFilterQueryString(e.value)
  }

  componentDidMount () {
    this.loadMyOrders(0, this.props.daysFilter)
    this.selectOnChange({ text: 'no último mês', value: 30 })
  }

  handleOnFilterSelect = (value) => {
    this.setState({ filterSelected: value })

    const start = moment(value.startDate)
    const end = moment(value.endDate)
    const duration = moment.duration(end.diff(start))
    this.selectOnChange({ text: 'no último 1 ano', value: duration.asDays() })
    this.loadMyOrders(0, duration.asDays())
  }

  render () {
    let products = []
    if (this.props.ready) products = this.props.productOrders
    else products = constants.PRODUCTSPLACEHOLDER
    return (
      <Fragment>
        <Helmet>
          <title>{`Seus pedidos - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-orders container-fluid px-0 px-md-1 pt-0'>
          <div className='container pl-2 pr-2 pb-2 pt-0 pt-md-5'>
            <div className='row'>
              <LoggedSidebar
                selected={this.props.location.pathname}
                ready={this.props.ready}
              />
              <div className='user-content col-12 col-lg-8 border-color-ui-3 bg-white border radius'>
                <div className='row px-1 py-2 border-bottom border-color-ui-3 '>
                  <Title ready={this.props.ready} />
                </div>

                <div className='row py-1 border-bottom border-color-ui-3 bg-ui-4'>
                  <Filters
                    options={this.state.currentTab.options.slice(2, 7)}
                    onFilterSelect={this.handleOnFilterSelect}
                    filterSelected={this.state.filterSelected}
                    currentTab={this.state.currentTab}
                  />
                </div>

                <InfiniteScroll
                  pageStart={0}
                  loadMore={() => this.loadMyOrders()}
                  hasMore={this.props.hasMoreItems}
                  loader={<MyOrdersPlaceholderItem page={this.props.page} />}
                  key={10}
                  initialLoad={false}
                >
                  <ProductOrderList
                    productOrders={products}
                    ready={this.props.ready}
                    loading={this.props.loading}
                    previousRoute={this.props.currentRoute}
                    packageSize={this.props.packageSize}
                  />
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

MyOrders.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  productOrders: PropTypes.array,
  hasMoreItems: PropTypes.bool,
  loadMyOrders: PropTypes.func,
  page: PropTypes.number,
  ready: PropTypes.bool,
  loading: PropTypes.bool,
  daysFilter: PropTypes.number,
  setFilterQueryString: PropTypes.func,
  currentRoute: PropTypes.string,
  packageSize: PropTypes.string
}

export default MyOrders



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/MyOrders.js